export default "__VITE_ASSET__7ZezhDj9__"